import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Client } from '../models/client.model';
import { Order } from '../models/order.model';
import { ApiResponse } from '../models/factory.model';
import { environment } from 'environments/environment';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Country } from '../models/country.model';
import { Reservation } from '../models/reservation';
import { ReservationRequestDTO } from '../dtos/reservation-request-dto';
import { UserService } from './user.service';
import { ReservationSearchService } from './reservation-search.service';
import { KeycloakService } from 'keycloak-angular';



@Injectable({
  providedIn: 'root'
})


export class ReservationService {
  // adding traitment
  private createrese = environment.api+"/reservations"
  //end traitement
  private crmUrl = environment.crmTest;
  private pmsUrl = environment.api;

  private ApiReservations:string = "https://bob.fractalite.com/beds/to/pms?property=1&";
  private fromProductUrl: string = environment.crmTest + '/order/fromproducts?dailyitem=true'; 

  // private fromProductUrl: string = "http://metisapi.fractal-sales.com/api/order/fromproducts";
  private orderPostUrl: string = environment.crmTest + '/order/';
  private EventUrl: string = environment.crmTest + '/order/';
  private orderPostUrlA: string = environment.crmTest + '/order';
  private createClient: string =  environment.crmTest + '/naturalpersons';
  private createClient2: string =  environment.crmTest + '/persons';
  private orderPostUrlComande:string = "https://bob.fractalite.com/beds/to/pms/order/hold?crm="+environment.crmTest;
  private orderPostUrlComandeconfirmed:string = "https://bob.fractalite.com/beds/to/pms/order/confirm?crm="+environment.crmTest;
  private orderPostUrlComandecancled:string = "https://bob.fractalite.com/beds/to/pms/order/cancel?crm="+environment.crmTest;
  private roomDisponibleUrlAPI: string = environment.api+"/checkins/roomsr/CLEAN?startService=";
  private urlCountries : string = environment.crmTest + '/countries?page=';
  private roomDisponibleUrl: string
  private Date:string = '';
  private resaExportUrl : string = environment.crmTest + "/export/allRservat/v2";
  httpOptions = {  
    headers: new HttpHeaders({'Authorization': 'Bearer Ouw4hte62nT30oO6Nso0IHCe14F9ldEP'})
  
  }

  // http://bob.fractalite.com/beds/to/pms?property=2&checkin=2023-01-15&nights=5&guests=2
  // private ApiReservations:string = "http://services.fractal-travel.com/stay/quote?"
// /Users/fractalite/Documents/PMS_valaria_audit/PMS/src/app/Pages/Front-desk/audit-report/audit-report.component.html
  constructor(private http: HttpClient,
             private userService: UserService,
             private reservationSearchService: ReservationSearchService,
             private keycloak: KeycloakService,
             ) {
               this.initializeDateClosed();
             }

  private initializeDateClosed(): void {
    const currentPath = window.location.pathname;
    const isPublicRoute = currentPath.includes('/pre-checkin') || 
                          currentPath.includes('/housemaid/reporting');
    
    if (isPublicRoute) {
      console.log('ReservationService: Skipping getDateClosed on public route');
      return;
    }

    const dateClosed$ = this.userService.getDateClosed();
    if (dateClosed$) {
      dateClosed$.subscribe(
        (response: string) => {
          this.Date = response;
        },
        (error) => {
          console.warn('ReservationService: Error fetching date closed:', error);
        }
      );
    }
  }

  getReservations(elements: any[], checkinDate: string, checkoutDate: string){
    this.ApiReservations = "http://services.fractal-travel.com/stay/quote?";
    this.ApiReservations += "ci=" + checkinDate + "&co=" + checkoutDate+"&rooms=";
    elements.forEach(element => {
      this.ApiReservations += "18,".repeat(element.guests);
      element.kids.forEach(kid => {
        this.ApiReservations += kid + ",";
      })
      this.ApiReservations = this.ApiReservations.substring(0, this.ApiReservations.length-1);
      this.ApiReservations += ";";
    })
    this.ApiReservations = this.ApiReservations.substring(0, this.ApiReservations.length-1);
    this.ApiReservations += "&model=mercure&code=apitude-FR002277&order=desc"
    return this.http.get(this.ApiReservations);
  }

  getRoomDisponible(checkinDate: string, checkoutDate: string):Observable<any>{
  this.roomDisponibleUrl = this.roomDisponibleUrlAPI + checkinDate + '&endService=' + checkoutDate + '';
  return this.http.get(this.roomDisponibleUrl);
  }

  getOrderFromProduct(product: any[]){
    // let urlFromProduct = this.fromProductUrl +
    return this.http.post(this.fromProductUrl, product);
  }
  getOrderFromProductABC(product: any[],orderId:any){
    // let urlFromProduct = this.fromProductUrl +
    this.fromProductUrl +='&orderid='+orderId;
    return this.http.post(this.fromProductUrl, product);
  }
  getalllegalforms(){
    let url = this.crmUrl + '/alllegalforms';
    return this.http.get(url);
  }
  getTypeevent(){
    let url = this.crmUrl + '/audit/allevent/type';
    return this.http.get(url);
  }
  getTaxe(idItem:any,currency:any,customerId:any):Observable<Order>{
    let url = this.crmUrl + '/item/generate/taxes/v2?itemid=' + idItem + '&currency='+currency+'&customer='+customerId+'&groupid='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get<Order>(url);
  }

 /** GET person by id. Will 404 if id not found */
 getCountryByName(term: string): Observable<Country[]> {
  const url = `${environment.crmTest}/countries?name=${term}&lang=fr`;
  
  // Use pipe() and map()
  return this.http.get<ApiResponse<Country>>(url).pipe(
    map((res: ApiResponse<Country>) => {
      return res.content;
    })
  );
}
  makecancellation(id:any,reason:any,price:any,userId){
  let url = this.createrese + '/cancel/'+id+'?price='+price+'&reason='+reason+'&user='+userId;
  return this.http.get(url);
  }

  puteventNote(event){
    let url  =  this.crmUrl + '/audit/event';
    return this.http.put(url, event);
  }
  
  CheckExistBookings(customer:any,bookingId:any){
    let url  =  this.createrese + '/exists';
    url = url + '?&customer='+customer+'&number='+bookingId+'&groupId='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get<boolean>(url);
  }

  getReservationsByStatus(fromDate: string, toDate: string, status: number, groupId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.api}/reservations?from=${fromDate}&to=${toDate}&resastatus=${status}&group=${groupId}`);
  }



  ///// test
  getAllRoles(){
    let url = this.crmUrl + '/allroles';
    return this.http.get(url);

  }
  getAllTagsForHotelSearchTest(): Observable<any> {
   
    
    return this.http
    //http://beds-sapi.sotlamer.travel/datasets/tag_type
    //`${BEDS_API}/datasets/tag_type`
    .get("http://beds-sapi.sotlamer.travel/datasets/tag_type",
    this.httpOptions
    )
    .pipe(map((data: any) => data ));
  } 
  getCountries(page:any):Observable<any>{

    return this.http.get(this.urlCountries+`${page}`);
  }
  getCountriesAll():Observable<any>{
    let urlcountries = environment.crmTest + '/allcountries'
    //  let urlcountries = 'https://crmapi.valeriahotels.com/api/allcountries';
     return this.http.get(urlcountries)
  }
 

  getBack(itemId: any, serviceDate: any): Observable<string> {
    const url = `${this.crmUrl}/orders/${itemId}/bac?closingdate=${serviceDate}`;
    return this.http.get(url, { responseType: 'text' });
  }
  
  getReservationsV2(elements: any[], checkinDate: string, nights: number, clientID: any, segment: any,creationDate ?: any) {
    // Create an array of Observables for the HTTP requests
    console.log("elements",elements);
    //let apiUrl = "http://bob.fractalite.com/beds/to/pms/quotes?property="+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+"&"
    let apiUrl = "https://bob.fractalite.com/beds/to/pms/quotess?property="+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+"&"

    console.log("in the service holder?.roomsInformation AA,",elements)
    if(clientID !== undefined) {
      if(segment !== undefined) {
          apiUrl += "client=" + clientID;
          // apiUrl += "&segment=" + segment;
          apiUrl += "&channel=" + segment;


      }
    }else{ 
      if(this.reservationSearchService.canal !== undefined){
        apiUrl += "&channel=" + this.reservationSearchService.canal
      }
    }
    apiUrl += "&checkin=" + checkinDate + "&nights=" + nights
    const requests = elements.map(element => {
        // let apiUrl = "http://bob.fractalite.com/beds/to/pms/quotes?property=1&";
        apiUrl +=  "&guests=" + element.guests; 
        element.kids.forEach(kid => {
            apiUrl += ";" + kid;
        });
        console.log("API URL for element:", apiUrl);
    });
    apiUrl = apiUrl + '&crm='+environment.crmTest
     if (creationDate){
         apiUrl = apiUrl +'&bookingDate='+ creationDate
     }
    else if( this.Date.trim() !==''){
      apiUrl = apiUrl +'&bookingDate='+this.Date
    }
    // Convert the array of Observables into a single Observable stream and execute each request
    return this.http.get(apiUrl);
   }
   getReservationsV2Forced(elements: any[], checkinDate: string, nights: number, clientID: any, segment: any,creationDate ?: any) {
    // Create an array of Observables for the HTTP requests
    console.log("elements",elements);
    let apiUrl = "https://bob.fractalite.com/beds/to/pms/quotess?property="+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+"&"
    console.log("in the service holder?.roomsInformation AA,",elements)
    if(clientID !== undefined) {
      if(segment !== undefined) {
          apiUrl += "client=" + clientID;
          // apiUrl += "&segment=" + segment;
          apiUrl += "&channel=" + segment;

      }
    }else{
      if(this.reservationSearchService.canal !== undefined){
        apiUrl += "&channel=" + this.reservationSearchService.canal
      }
    }
    apiUrl += "&checkin=" + checkinDate + "&nights=" + nights
    const requests = elements.map(element => {
        // let apiUrl = "http://bob.fractalite.com/beds/to/pms/quotes?property=1&";
        apiUrl +=  "&guests=" + element.guests; 
        element.kids.forEach(kid => {
            apiUrl += ";" + kid;
        });
        console.log("API URL for element:", apiUrl);
    });
    apiUrl = apiUrl + '&ignoreAvailability=true'
    apiUrl = apiUrl + '&crm='+environment.crmTest
       if (creationDate){
           apiUrl = apiUrl +'&bookingDate='+ creationDate
       }
       else if( this.Date.trim() !==''){
           apiUrl = apiUrl +'&bookingDate='+this.Date
       }
    // Convert the array of Observables into a single Observable stream and execute each request
    return this.http.get(apiUrl);
   }
   getReservationsV2Past( Adult:any, Child:any[],checkinDate: string, nights: number, client: any, bookingDate:any) {
    // Create an array of Observables for the HTTP requests

        // let apiUrl = "http://bob.fractalite.com/beds/to/pms/quotes?property=1&";
        let apiUrl = "https://bob.fractalite.com/beds/to/pms/quotess?property="+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+"&"
         // here for put customer and segment
       
         if(client.segments.length !== 0){
          apiUrl += "client="+client.id
          // apiUrl += "&segment=" + client.segments[0].name;
          apiUrl += "&channel=" + client.segments[0].segmentId;
         }else{
          apiUrl += "&channel=15";
         }      
        // here for put number of the pax and age of child 
        apiUrl += "&checkin=" + checkinDate + "&nights=" + nights + "&guests=" + Adult;
        if(Child.length !== 0){
          Child.forEach(kid => {
            apiUrl += ";" + kid;
        })
        }
        // and here for put bookingDate
        apiUrl += "&bookingDate="+bookingDate 
        console.log("API URL for element:", apiUrl);
        apiUrl = apiUrl + '&crm='+environment.crmTest
        apiUrl = apiUrl + '&ignoreAvailability=true'
        console.log("this apiUrl = ",apiUrl);
        // Create an Observable for the HTTP GET request
        return this.http.get(apiUrl, this.httpOptions);
   }
  


  getClientbyID(id: any): Observable<any> {
    console.log("in service get", this.createClient2 + `/${id}`);
    let url = this.createClient2 + `/${id}`;
    return this.http.get<any>(url);
  }

  getTypeFree(): Observable<any> {
    let url = environment.crmTest + '/free-item-detail-types';
    return this.http.get<any>(url);
  }

  createCustomer(client: any): Observable<any> {
    let url: string;

    // 1. Cas Personne Physique (NATURAL ou PHYSICAL)
    // On vérifie les deux cas au cas où votre select envoie 'PHYSICAL'
    if (client.personType === 'NATURAL') {
      
      url = `${environment.crmTest}/naturalpersons`;
      
    } 
    // 2. Cas Personne Morale (LEGAL)
    else {
      
      url = `${environment.crmTest}/legalpersons`;

      // Logique pour s'assurer que socialReason est rempli pour le backend
      // (Si le formulaire a rempli 'name', on le copie dans 'socialReason')
      if (client.name && !client.socialReason) {
        client.socialReason = client.name;
      }
    }

    // Envoi de la requête POST
    return this.http.post<any>(url, client);
  }

  CreateClientA(client: Client): Observable<any> {  
    let url:any =  environment.crmTest + '/naturalpersons'; 
    return this.http.post(url, client);
  }

  CreateClient(client: Client): Observable<any> {   
    return this.http.post(this.createClient, client);
  }

  CreateAvoir(Avoir:any): Observable<any> {
     let url = environment.crmTest + '/credit-notes'
     return this.http.post(url, Avoir);
  }
   ConectAvoirInvoice(Avoir: any, Invoice: any): Observable<any> {
    const url = `${environment.crmTest}/${Avoir.invoiceId}/add-invoice/${Invoice.invoiceId}`;
    return this.http.post(url, null); // ✅ null body
   }
   
  updatedClient(client: Client){   
    return this.http.put(this.createClient+'/'+client.id, client);
  }
  postOrder(order: any,event?:string){
    order.events.push(event);
    console.log("in service order",order);
    let url = this.orderPostUrl+`${order.orderId}` 
    return this.http.put<ApiResponse<Order>>(url, order, { observe: 'response' });

  }

  postOrderPayment(order: any, payment: any, event?: string) {
    if (!order.events) {
      order.events = [];
    }

    if (event) {
      order.events.push(event);
    }

    console.log('in service order', order);
    console.log('payment to add', payment);

    const url = environment.crmTest + '/orders/' + order.orderId + '/add/payment';

    return this.http.post<ApiResponse<any>>(url, payment, {
      observe: 'response'
    });
  }
  postOrderConfirm(order: any,event?:string){
    order.events.push(event);
    console.log("in service order",order);
    let url = this.orderPostUrl+`${order.orderId}?&numberAutoGenerated=true`
    return this.http.put<ApiResponse<Order>>(url, order, { observe: 'response' });

  }
  postOrderA(order: any){
    console.log("in service order",order);
    let url = this.orderPostUrl+`${order.orderId}` 
    return this.http.put<ApiResponse<Order>>(url, order, { observe: 'response' });

  }
  CreOrder(order: any){
    console.log("in service order",order);
    let url = this.orderPostUrl 
    return this.http.post<ApiResponse<Order>>(url, order, { observe: 'response' });

  }
 
  postCredet(idaccountId: any,value:any){
    console.log("idaccountId",idaccountId);
    console.log("value",value);
    let url = environment.crmTest+`/customeraccount/${idaccountId}/pay/${value}` ;
    return this.http.get(url);
  }
   SaveEvent(order: any, archivetxt: string) {
    console.log("I am now in the event service: " + archivetxt);
    console.log("In service order: ", order);
  
    // Construct the URL with query parameters
    const url = `${this.EventUrl}${order.orderId}/event/${encodeURIComponent(archivetxt)}`;
    console.log("URL event: ", url);
    
    // Send a GET request
    return this.http.get(url);
  }
  
   getAllExchangeRates(): Observable<any> {
    let apiurl = environment.crmTest + '/exchange/all/v2'
    return this.http.get<any>(apiurl);
  }

  // GET /exchange/v2/:id
  getExchangeById(id: number) {
    let apiurl = environment.crmTest + '/exchange/v2'
    return this.http.get(`${apiurl}/${id}`);
  }

  
 getCurrenciesFromJson(): Observable<any> {
  return this.http.get<any>('assets/data/currencies.json');
}



  // PUT /exchange/v2
  updateExchange(data: any) {
    let apiurl = environment.crmTest + '/exchange/v2'
    return this.http.put(apiurl, data);
  }

  createExchange(exchange: any): Observable<any> {
    let apiurl = environment.crmTest + '/exchange/v2'
    return this.http.put(apiurl, exchange);
  }

  sendEmail(orderId: string,email : string,groupId:any){
    let code:any = 0;
    if(groupId == 1){
      code = 305473;
    }
    if(groupId == 2){
      code = 305489;
    }
    if(groupId == 3){
      code = 305503;
    }
    const url = `${this.crmUrl}/ordermessage/sendmessage/${code}/order/${orderId}?email=${email}`
    console.log("send Email url");
    return this.http.get(url);
  }

  sendPayment(orderId: string,email : string,groupId:any,topay:any){
    let code:any = 0;
    if(groupId == 1){
      code = 305478;
    }
    if(groupId == 2){
      code = 305493;
    }
    if(groupId == 3){
      code = 305508;
    }
    const url = `${this.crmUrl}/ordermessage/sendmessage/${code}/order/${orderId}?email=${email}&toPay=${topay}`
    console.log("send Email url");
    return this.http.get(url);
  }
  // postOrder(order: Order, orderId: number, archive: boolean, sendnotif: boolean, archivetxt: string) {
  //   let url = `${this.apiRoot}/api/order/${orderId}?`;
  //   if (archive) {
  //     url = url + `archive=true`;
  //   }else{
  //     url = url + `archive=false`;
  //   }
  //   if (sendnotif) {
  //       url = url + `&sendnotif=true`;
  //   } else {
  //       url = url + `&sendnotif=false`;
  //   }
  //   if (archivetxt != '') {
  //     url = url + `&archivetxt=/${archivetxt}`;
  //   }

  //   return this.http.put<ApiResponse<Order>>(url, order, { observe: 'response' });
  // }
  postOrderCommande(order: any): Observable<any>{
    const A =  "user:" + JSON.parse(localStorage.getItem("userDetails")).name + "&Detail:Order created "+ "&Date:" + this.getCurrentDateTime().replace(/\n/g, '');

    return this.http.post(this.orderPostUrlComande, order);
  }
  postOrderCommandeConfirmed(Preoder: any,event?:string): Observable<any>{
    console.log('event',event)
    if (event)
      Preoder.events.push(event);
    return this.http.post(this.orderPostUrlComandeconfirmed, Preoder);
  }
  postOrderCommandeCancled(Preoder: any): Observable<any>{
    return this.http.post(this.orderPostUrlComandecancled, Preoder);
  }
  postOrderAchat(order: any): Observable<any>{
    console.log("in service order Interla",order);
    order.status =order.items[0].status;
    return this.http.post(this.orderPostUrlA, order);
  }
   postOrder2(order: any): Observable<any>{
    return this.http.post(this.orderPostUrlA, order);
  }
  postOrderEd(order: Order, orderId: number,archive:boolean,archivetxt):Observable<any> {
    let url = `${this.orderPostUrlA}/${orderId}?`;
    console.log("order by hosam",order);
    if (archive) {
      url = url + `&archive=true`;
    }else{
      url = url + `&archive=false`;
    }
    if (archivetxt != '') {
      url = url + `&archivetxt=/${archivetxt}`;
    }
    return this.http.put(url, order);
  }

  postReservation(reser: any): Observable<any> {   
    return this.http.post(this.createrese, reser);
  }
  getReservation(reser: any): Observable<any> {   
    return this.http.get(this.createrese+'/'+reser.itemId);
  }
  getReservationID(resaID: any): Observable<any> {   
    return this.http.get(this.createrese+'/'+resaID);
  }
  putReservation(reser: any): Observable<any> {   
    return this.http.put(this.createrese+'/'+reser.itemId, reser);
  }

 
  searchBeneficiaryByCriteria(criteria){
    return this.http
    .get(`${this.crmUrl}/persons?criteria=${criteria}&group=-1`)
    .pipe(map((data: any) => data.content));
  }
  searchBeneficiaryByCriterialegals(criteria){
    return this.http
    .get(`${this.crmUrl}/legals?criteria=${criteria}&group=-1`)
    .pipe(map((data: any) => data.content));
  }


  searchUserByCriteria(criteria){
    return this.http
    .get(`${this.crmUrl}/users??page=0&group=${JSON.parse(localStorage.getItem("userDetails")).group.groupId}&name=${criteria}`)
    .pipe(map((data: any) => data.content));
  }
    searchCountryByCriteria(criteria){
        return this.http
            .get(`${this.crmUrl}/countries?name=${criteria}&group=-1`)
            .pipe(map((data: any) => data.content));
    }

    searchAllBeneficiaries(){
        return this.http
            .get(`${this.crmUrl}/persons?&group=-1`)
            .pipe(map((data: any) => data.content));
    }
    searchAllCountries(){
        return this.http
            .get(`${this.crmUrl}/countries?size=5000&group=-1`)
            .pipe(map((data: any) => data.content));
    }

    searchBeneficiaryByCriteriaB(criteria){
    return this.http
    .get(`${this.crmUrl}/prospects?criteria=${criteria}&group=-1`)
    .pipe(map((data: any) => data.content));
  }

  valueToPay(percentage: boolean, value: number, price: number, nights: number) {
    var valueTopay = value.toFixed(2);;
    if (percentage === true) {
        valueTopay = ((value / 100) * price).toFixed(2);
    }else{
      valueTopay = String(price-value);
    }
    return valueTopay;
  }


  getCurrentDateTime(): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const now = new Date();
    const month = months[now.getMonth()];
    const date = now.getDate();
    const year = now.getFullYear();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    return `${month}-${date}-${year} ${hours}:${minutes}`;
  }

  fetchReservation(requestDTO: ReservationRequestDTO): Observable<Reservation[]>{

    const queryParams = this.reservationRequestFilter(requestDTO);

    return this.http.get<Reservation[]>(`${this.pmsUrl}/reservations`, { params: queryParams });
  }

  reservationRequestFilter(requestDTO: ReservationRequestDTO): HttpParams {
    let queryParams = new HttpParams();

    queryParams = queryParams.set('group', JSON.parse(localStorage.getItem("userDetails")).group.groupId);

    if (requestDTO != null) {

      if (requestDTO.room) {
        queryParams = queryParams.set('room', requestDTO.room);
      }

      if (requestDTO.resastatus) {
        queryParams = queryParams.set('resastatus', requestDTO.resastatus);
      }

      if (requestDTO.from) {
        queryParams = queryParams.set('from', requestDTO.from);
      }

      if (requestDTO.to) {
        queryParams = queryParams.set('to', requestDTO.to);
      }

      if (requestDTO.createdfrom) {
        queryParams = queryParams.set('createdfrom', requestDTO.createdfrom);
      }

      if (requestDTO.createdto) {
        queryParams = queryParams.set('createdto', requestDTO.createdto);
      }

      if (requestDTO.boNumber) {
        queryParams = queryParams.set('boNumber', requestDTO.boNumber);
      }

      if (requestDTO.customer) {
        queryParams = queryParams.set('customer', requestDTO.customer);
      }

      if (requestDTO.guest) {
        queryParams = queryParams.set('guest', requestDTO.guest);
      }
    }

    return queryParams;
  }



    exportReservations(checkinFrom: string, checkinTo: string, checkoutFrom: string, checkoutTo: string): Observable<Blob> {
        const params = {
            group: JSON.parse(localStorage.getItem("userDetails")).group.groupId ,
            type: 'Customer',
            startservice: this.formatDate(checkinFrom),
            endservice: this.formatDate(checkinTo),
            startendservice: this.formatDate(checkoutFrom),
            endendservice: this.formatDate(checkoutTo)
        };


        const queryString = new URLSearchParams(params).toString();
        const url = `${this.resaExportUrl}?${queryString}`;

        return this.http.get(url, { responseType: 'blob' });
    }

    private formatDate(date: string): string {
        if (!date) return '';
        const d = new Date(date);
        return d.toISOString().split('T')[0];
    }

  GteAllotement(type: any) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const propertyId = userDetails?.group?.attributes?.[0]?.value || userDetails?.group?.id || 168;
      const token = 'Bearer ' + this.keycloak.getKeycloakInstance().token;
      const url = `https://beds-api.fractalite.com/properties/${propertyId}/units/${type}/allotments`;

      console.log("📡 API URL:", url);

      return this.http.get(url, {
        headers: new HttpHeaders({ 'Authorization': token }),
      });
    }

  GteAllotementByDate(code,id,date1,date2){
    let url = 'https://beds-api.fractalite.com/properties/';
    let token = 'Bearer ' + this.keycloak.getKeycloakInstance().token;
    return this.http.get(url+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+'/units/'+id+'/allotments/'+code+'/calendar?$sort=date%3C&end='+date2+'&start='+date1,{headers: new HttpHeaders({
           'Authorization': token
    })});
  
  }

  searchCustomersByCriteria(criteria: string, groupId: number): Observable<any[]> {
    return this.http
      .get(`${this.crmUrl}/customers?criteria=${criteria}&group=${groupId}`)
      .pipe(map((data: any) => data.content)); 
  }


  searchAllBeneficiariesWithGroupId(groupId: number): Observable<any[]> {
    return this.http
      .get(`${this.crmUrl}/customers?group=${groupId}`) 
      .pipe(map((data: any) => data.content)); 
  }


    getDispoReservation(from: any, to: any) {
  const groupId = JSON.parse(localStorage.getItem("userDetails")!).group.groupId;

  // ✅ Ajouter +1 jour à la date de fin uniquement pour l'appel API
  const end = new Date(to);
  end.setDate(end.getDate() + 1);
  const endStr = end.toISOString().substring(0, 10); // format YYYY-MM-DD

  // 🔹 Construire l’URL complète
  const url = `${this.createrese}/daily-counts?group=${groupId}&from=${from}&to=${endStr}`;

  return this.http.get(url);
}
  
}
